import React, { Component } from 'react';
import CreateLiveStreamButton from "./CreateLiveStreamButton";
import * as encryptUtils from "./encryptDecryptUtils";
import * as loggingUtils from "./utils/loggingUtils";

class CreatorDashboardProfileUsername extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="flex flex-col w-8/12 mt-8">
        <div className="flex flex-col">
          <div className="text-zinc-400 font-semibold text-md">
            Displayed Name
          </div>
          <div>
            <form className="flex">
              <input
                className="border-zinc-600 rounded-md border bg-custom-gray text-zinc-400 h-10 w-full px-2"
                type="text"
                name="username"
                value={this.props.username}
                maxLength={20}
                required
                onChange={this.props.setUsername}
              />
            </form>
          </div>
          <div className="text-zinc-400 font-semibold text-md">
            URL Route
          </div>
          <div>
            <form className="flex">
              <input
                className="border-zinc-600 rounded-md border bg-custom-gray text-zinc-400 h-10 w-full px-2"
                type="text"
                name="route"
                value={this.props.route}
                maxLength={20}
                required
                onChange={this.props.setRoute}
              />
            </form>
          </div>
        </div>
        <div className="flex flex-col">
          <div className="text-zinc-400 font-semibold text-md">
            URL
          </div>
          <div>
            <div className="text-xs sm:text-base text-zinc-400 h-10 w-full">
              {window.location.origin + "/profile/" + this.props.route}
            </div>
          </div>
        </div>
        <CreateLiveStreamButton
          isForCreatorDashboard={true}
          isForStreamerProfile={false}
          streamName={this.props.creatorAddress}
        />
      </div>
    );
  }
}

export default CreatorDashboardProfileUsername;
